import { exampleUserRoleScopes, UserRoleScopes } from './UserRoleScopes';
import {
  exampleUserRoleNotifications,
  UserRoleNotifications,
} from './UserRoleNotifications';

export enum UserRolesBehavior {
  Developer = 'developer',
  Admin = 'admin',
  PodMember = 'pod_member',
  Assigned = 'assigned_only',
}

export enum UserRolesType {
  Employee = 'employee',
  Client = 'client',
}

export interface UserRole {
  id: number;
  name: string;
  behavior: UserRolesBehavior;
  type: UserRolesType;
  scopes: UserRoleScopes;
  notifications: UserRoleNotifications;
}

export const exampleUserRole: UserRole = {
  id: 1,
  name: 'Test Role',
  behavior: UserRolesBehavior.Admin,
  type: UserRolesType.Employee,
  scopes: exampleUserRoleScopes,
  notifications: exampleUserRoleNotifications,
};
